import { extensions } from './extensions';
import { plans } from './plans';

export default {
	plans,
	extensions
};
